// Landing page test IDs — every interactive / user-facing element should have one.

export const LANDING = {
  // Nav
  navLogo: 'landing-nav-logo',
  navExplore: 'landing-nav-explore',
  navWaitlist: 'landing-nav-waitlist',

  // Hero
  heroExploreBtn: 'hero-explore-collection-btn',
  heroWaitlistBtn: 'hero-join-early-access-btn',
  heroTumbler: 'hero-tumbler',

  // Collections
  collectionCorporate: 'collection-card-corporate',
  collectionGirls: 'collection-card-girls',
  collectionGenz: 'collection-card-genz',

  // Challenge
  challengeQR: 'challenge-qr-code',

  // Lifestyle
  lifestyleGallery: 'lifestyle-gallery',

  // Future vision
  futureTimeline: 'future-vision-timeline',

  // Waitlist
  waitlistForm: 'waitlist-form',
  waitlistName: 'waitlist-name-input',
  waitlistEmail: 'waitlist-email-input',
  waitlistSubmit: 'waitlist-submit-btn',
  waitlistSuccess: 'waitlist-success-banner',
  waitlistError: 'waitlist-error-banner',
  waitlistCount: 'waitlist-count-badge',
};
